import React from 'react';

import { observer } from 'mobx-react';

import { YesNoBtnRow } from '@infoods/lifebase-ui';

import classes from './ButtonsRow.module.scss';
import { stepperStore } from '../../../../stores/stepperStore';

type ButtonsRowProps = {
  yesDisabled?: boolean;
  yesText?: string;
  yesHandler?: () => void;
  children?: React.ReactNode;
};

const ButtonsRow = observer(
  ({ yesDisabled, yesText = 'Continue', children, yesHandler }: ButtonsRowProps) => {
    const { openDeclineModal, nextStep } = stepperStore;
    const yesBtnHandler = yesHandler || nextStep;

    return (
      <YesNoBtnRow
        yesDisabled={yesDisabled}
        yesText={yesText}
        noText="Decline"
        noHandler={openDeclineModal}
        yesHandler={yesBtnHandler}
        className={classes.btnBox}
      >
        {children}
      </YesNoBtnRow>
    );
  },
);

export { ButtonsRow };
